import { NavigationExtras } from '@angular/router';

import { QualityTrafficLights } from '../../shared/models/common/quality-traffic-lights.enum';

/* ── Discriminated union for SuiCommandItem.data ─────────── */
/* Used by the result template to @switch on resultType       */

export type CmdItemData =
  | CmdNavigation
  | CmdAction
  | CmdRecentActivity
  | CmdFullTextSearch
  | CmdRecentSearch
  | CmdDealResult
  | CmdDatapointResult
  | CmdDefinedTermResult
  | CmdTopicResult
  | CmdManagerResult
  | CmdChecklistResult;

export interface CmdNavigation {
  resultType: 'navigation';
  link: string[];
  extras?: NavigationExtras;
}

export interface CmdAction {
  resultType: 'action';
  action: () => void;
}

export interface CmdRecentActivity {
  resultType: 'recent-activity';
  link: string[];
  extras?: NavigationExtras;
  entityType: string;
}

export interface CmdFullTextSearch {
  resultType: 'full-text-search';
  query: string;
}

export interface CmdRecentSearch {
  resultType: 'recent-search';
  searchTerm: string;
}

export interface CmdDealResult {
  resultType: 'deal';
  link: string[];
  transactionId: string;
  qualityTrafficLight?: QualityTrafficLights;
  isPrivate?: boolean;
  autoPublished?: boolean;
  hasLatestIssuance?: boolean;
  issuanceType?: string;
  endOfLife?: boolean;
  libraryDisplayName?: string;
  managerDisplayName?: string;
  transactionShortName?: string;
}

export interface CmdDatapointResult {
  resultType: 'datapoint';
  link: string[];
  extras?: NavigationExtras;
  displayType?: string;
  refId?: string;
  displayShortName?: string;
}

export interface CmdDefinedTermResult {
  resultType: 'defined-term';
  link: string[];
  extras?: NavigationExtras;
  documentCount?: number;
}

export interface CmdTopicResult {
  resultType: 'topic';
  link: string[];
  editLink?: string[];
  builtIn?: boolean;
  inMyTopics?: boolean;
  refId?: string;
  displayShortName?: string;
}

export interface CmdManagerResult {
  resultType: 'manager';
  link: string[];
  queryParams?: Record<string, unknown>;
}

export interface CmdChecklistResult {
  resultType: 'checklist';
  link: string[];
  editLink?: string[];
  refId?: string;
  shared?: boolean;
}

/* ── Entity type → icon mapping ──────────────────────────── */

export const ENTITY_ICON_MAP: Record<string, string> = {
  transaction: 'briefcase',
  manager: 'buildings',
  'datapoint-field': 'database',
  'datapoint-rule': 'database',
  formula: 'math-operations',
  topic: 'rows',
  checklist: 'list-checks',
};
